/* eslint no-unused-vars: 0 */

/**
 * This file was automatically generated by ruby_to_typescript.rake.
 * Do not modify it by hand.
 */
export enum SegmentEventName {
  ABANDON = "Abandon",
  ACCEPT = "Accept",
  ADD_TO_NETWORK = "AddToNetwork",
  ADVANCE = "Advance",
  ARCHIVE = "Archive",
  BOUNCE = "Bounce",
  CLAIM_PROFILE = "ClaimProfile",
  CLICK = "Click",
  COMPLETE_ONBOARDING = "CompleteOnboarding",
  CREATE = "Create",
  DECLINE = "Decline",
  DOWNVOTE = "Downvote",
  FOLLOW = "Follow",
  INVITE = "Invite",
  LOGIN = "Login",
  LOGOUT = "Logout",
  SEND_MESSAGE = "SendMessage",
  RECEIVE_MESSAGE = "ReceiveMessage",
  OPEN = "Open",
  RECEIVE_ANSWER = "ReceiveAnswer",
  REFER = "Refer",
  REPLY = "Reply",
  REQUEST_TO_JOIN_NETWORK = "RequestToJoinNetwork",
  RESUBSCRIBE = "Resubscribe",
  REVIEW = "Review",
  SEARCH = "Search",
  SEND = "Send",
  SHARE = "Share",
  SPAM_COMPLAINT = "SpamComplaint",
  SUBMIT = "Submit",
  UNFOLLOW = "Unfollow",
  UNSUBSCRIBE = "Unsubscribe",
  UPDATE = "Update",
  UPDATE_KEYWORDS = "UpdateKeywords",
  UPDATE_INTEREST = "UpdateInterest",
  UPVOTE = "Upvote",
  VIEW = "View",
}
